// extracted by mini-css-extract-plugin
module.exports = {"contentInfoPainelsForm":"style_contentInfoPainelsForm__SrGWC","border":"style_border__WkEX_","containerContact":"style_containerContact__vzrAK"};